const LOCALE_MAPPER = {
	ca: 'cat',
	el: 'gr',
	vi: 'vn',
	tw: 'zh-tw',
	br: 'pt',
	us: 'en',
	tl: 'en',
}

export const normalizeFlatpickrLocale = locale => LOCALE_MAPPER[locale] ?? locale
